const ITEMS = [
  "Est. 1777",
  "Tobago, Trinidad & Tobago",
  "A Heritage Estate",
  "Coastline",
  "Rainforest",
  "Rivers & Waterfalls",
  "Cocoa Heritage",
  "A Living Landscape",
  "An Enduring Vision",
];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center">
        <span className="font-display italic text-3xl md:text-5xl text-ivory/90 px-8 md:px-12 whitespace-nowrap">{t}</span>
        <span className="h-2 w-2 rotate-45 bg-gold" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="overflow-hidden border-y border-gold/30 bg-heritage py-8 md:py-10" data-testid="editorial-marquee">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
  </section>
);
